// extracted by mini-css-extract-plugin
module.exports = {"button":"_22wH8OrqnQIcqXYBt2SFHv"};